"use strict";

const $ = jQuery;

module.exports = class {
	#$module;
    #$dropdownItems;
    #$toggleButtons;

	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$dropdownItems = $module.find('.dropdown-item');
        this.#$toggleButtons = this.#$dropdownItems.find('button');
        this.bind();
        this.matchHeights();
	}

    bind() {
        this.$toggleButtons.each((i, el) => {
            $(el).on('click', (event) => {
                return this.onToggleButtonClick(event, i);
            });
        });

        $(window).on('resize', (event) => {
            return this.onWindowResize(event);
        });
    }

    get $module() {
        return this.#$module;
    }

    get $dropdownItems() {
        return this.#$dropdownItems;
    }

    get $toggleButtons() {
        return this.#$toggleButtons;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.settings.id;
    }

    get moduleId() {
        return this.data.node;
    }

    matchHeights() {
        let maxHeight = 0;
        this.$dropdownItems.each((i) => {
            const itemHeight = Math.ceil(this.$dropdownItems.eq(i).outerHeight());
            maxHeight = (itemHeight <= maxHeight) ? maxHeight : itemHeight;
        });

        this.$dropdownItems.css('height', maxHeight);
    }

    hideAllDropdowns() {
        this.#$dropdownItems.attr('aria-expanded', 'false');
    }

    onToggleButtonClick(event, i) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        const $targetItem = this.#$dropdownItems.eq(i);

        if ($targetItem.attr('aria-expanded') === 'true') {
            $targetItem.attr('aria-expanded', 'false');
        } else {
            this.hideAllDropdowns();
            $targetItem.attr('aria-expanded', 'true');
        }
    }

    onWindowResize(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }
        this.matchHeights();
    }
}